// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"styles_qrcode__2JkYQ"};